export default __webpack_public_path__ + "static/media/m_wdt_c_0.f1d1803c.mp3";